"use strict";

let position = 0;
let movAmt = 0;
let timeOutFunctionId;

const testimonial_container = document.getElementById('testimonial_container');

const arrows = [...document.querySelectorAll('.triangle')];

if (testimonial_container) {
  const testimonial_amount = testimonial_container.children.length;

  testimonial_container.style.width = `${testimonial_container.parentNode.clientWidth * testimonial_amount}px`;

  const updatePosition = dir => {
    let active_height = 0;
    [...testimonial_container.children].forEach( (el,i) => {
      let kidHeight = 0;
      el.classList.remove('next','current','past');
      for (let kid of el.children) kidHeight = kidHeight + kid.clientHeight;
      el.style.height = `${kidHeight}px`;
      
      if (i > position) el.classList.add('next');
      if (i === position) {
        el.classList.add('current');
        active_height = kidHeight;
      }
      if (i < position) el.classList.add('past');
    });


    if (position === 0) {
      arrows[0].classList.add('__hidden');
      arrows[1].classList.add('__hidden');
    }
    if (position > 0 && position < testimonial_amount) {
      arrows[0].classList.remove('__hidden');
      arrows[1].classList.remove('__hidden');
      arrows[2].classList.remove('__hidden');
      arrows[3].classList.remove('__hidden');
    }
    if (position + 1 === testimonial_amount) {
      arrows[2].classList.add('__hidden');
      arrows[3].classList.add('__hidden');
    }

    if (dir === 'l') movAmt = movAmt - testimonial_container.parentNode.clientWidth;
    if (dir === 'r') movAmt = movAmt + testimonial_container.parentNode.clientWidth;

    testimonial_container.style.transform = `translate3d(${movAmt}px, 0, 0)`;
    testimonial_container.style.height = `${active_height}px`;
  }

  arrows.forEach(el => {
    el.addEventListener('click', e => {
      if ([...e.target.classList].includes('__right') && position < testimonial_amount - 1) {
        ++position;
        updatePosition('l');
      }
      else if ([...e.target.classList].includes('__left') && position > 0) {
        --position;
        updatePosition('r');
      }
    })
  });

  const {outerWidth} = window;
  window.addEventListener("resize", () => {
    clearTimeout(timeOutFunctionId); 
    timeOutFunctionId = setTimeout(() => {
      if (outerWidth === window.outerWidth) return;
      position = 0;
      movAmt = 0;
      testimonial_container.style.width = `${testimonial_container.parentNode.clientWidth * testimonial_amount}px`;
      updatePosition();
    }, 500); 
  });

  updatePosition();
}